









import { Component, Mixins } from "vue-property-decorator";
import mixins from "@/mixins";
// import { ERROR } from "../../constants";
// import { LegalRiskState } from "../../../../utils/enum";

@Component
class MixinAuth extends Mixins(mixins.publicPage) {
  back = false;

  loading = true;

  get title() {
    return this.$t("common.login") as string;
  }

  get code() {
    return this.$route.query.code as string;
  }

  get appbar() {
    return {
      show: false
    };
  }

  get state() {
    const state = this.$route.query.state as string;
    try {
      return JSON.parse(decodeURIComponent(state));
    } catch (error) {
      return "";
    }
  }

  get redirect() {
    return localStorage.getItem("redirect-path");
  }

  get type() {
    return this.state && this.state.type;
  }

  async requestToken() {
    try {
      await this.$store.dispatch("removeAccountData");
      const { access_token: token } = await this.$api.account.getTokenByMixin(
        this.code
      );
      this.$store.commit("auth/SET_TOKEN", { token });
      await this.$store.dispatch("initAccountData");
      this.$common.utils.helper.toast(this, {
        message: this.$t("account.login.success") as string,
        color: "success"
      });
      this.handleRedirect();
    } catch (error) {
      // if (error.code === ERROR.FORBIDEN_TO_USE) {
      //   this.$store.commit("app/SET_LEGAL_RISK_STATE", LegalRiskState.FORBIDEN);
      //   this.$router.push("wallet");
      //   return;
      // }

      this.$common.utils.helper.errorHandler(this, error);
      setTimeout(() => {
        this.handleRedirect();
      }, 2000);
    }
  }

  async requestBind() {
    try {
      await this.$store.dispatch("removeAccountData");
      await this.$api.account.bindMixin(this.code);
      await this.$store.dispatch("initAccountData");
      this.$nextTick(() => {
        this.handleRedirect();
      });
    } catch (error) {
      this.$common.utils.helper.errorHandler(this, error);
      setTimeout(() => {
        this.handleRedirect();
      }, 2000);
    }
  }

  handleRedirect() {
    if (this.redirect) {
      document.location.replace(this.redirect);
    } else {
      this.$helper.toFusionPath(this, "wallet", { name: "index" });
    }
  }

  mounted() {
    if (this.type === "bind") {
      this.requestBind();
    } else {
      this.requestToken();
    }
  }
}
export default MixinAuth;
